import { render } from "./ThemeToggle.vue?vue&type=template&id=2778e797&scoped=true"
import script from "./ThemeToggle.vue?vue&type=script&lang=js"
export * from "./ThemeToggle.vue?vue&type=script&lang=js"

import "./ThemeToggle.vue?vue&type=style&index=0&id=2778e797&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2778e797"]])

export default __exports__